<template>
  <div class="h-screen flex w-full bg-img vx-row no-gutter items-center justify-center" id="page-login">
    <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-3/4 xl:w-3/5 sm:m-0 m-4">
      <vx-card>
        <div slot="no-body" class="full-page-bg-color">

          <div class="vx-row no-gutter justify-center items-center">

            <div class="vx-col hidden lg:block lg:w-1/2">
              <img src="@/assets/images/pages/login.png" alt="login" class="mx-auto">
            </div>

            <div class="vx-col sm:w-full md:w-full lg:w-1/2 d-theme-dark-bg">
              <div class="p-8 login-tabs-container">

                <div class="vx-card__title mb-4">
                  <h4 class="mb-4">{{$t("ConfirmHandover")}}</h4>
                  <p style="margin-top: 70px" v-if="buttonDisabled">{{$t("HandoverApproved")}}</p>
                </div>

                <p v-if="!buttonDisabled" style="margin-top: 50px" >{{$t("HandoverNotes")}}</p>
                <vs-textarea v-if="!buttonDisabled" v-model="notes" class="w-full" />

                <div style="margin-top: 50px">
                  <vs-button :disabled="buttonDisabled" @click="approveHandover" >{{$t("ApproveHandover")}}</vs-button>
                </div>

              </div>
            </div>
          </div>
        </div>
      </vx-card>
    </div>
  </div>
</template>

<script>
export default{
  data() {
    return {
      buttonDisabled: false,
      notes: '',
    }
  },
  methods: {
    approveHandover() {
      this.$vs.loading();
      const thisIns = this;
      this.$http.post('/api/v1/approveHandover/' + this.$route.params.id, {
        notes: this.notes
      }).then(function () {
        thisIns.buttonDisabled = true;
        thisIns.$vs.loading.close();
      }).catch(function () {
        thisIns.$vs.loading.close();
        thisIns.$vs.notify({
          title:'Error',
          text: "Failed",
          color:'danger',
          iconPack: 'feather',
          icon:'icon-alert-circle'})
      });
    }
  }
}
</script>

<style lang="scss">
</style>
